import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { EinvoiceToIrbExportFileContainerModel } from "../../../../../../models/aggregates/erp/einvoice-to-irb-export/einvoice-to-irb-export.container.model";

@Injectable({ providedIn: "root" })
export class EinvoiceToIrbExportService extends BaseApiTemplateService<EinvoiceToIrbExportFileContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + "export/einvoice-to-irb-file-hdrs/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + "export/einvoice-to-irb-file-hdrs/backoffice-ep";
    this.httpClient = http;
  }
}